import { createApp } from 'vue';
import ListingSearchBar from './components/ListingSearchBar.vue';
import { createSearchApi } from './lib/searchApi';
import { filterConfig } from './lib/filterConfig';
import { routes } from './lib/routes';
import { useCriteria } from './lib/useCriteria';
import { setTranslations } from './lib/i18n';

const mountEl = document.querySelector('#listing-search');
const translationsEl = document.querySelector('[data-listing-translations]');

if (translationsEl) {
  setTranslations(JSON.parse(translationsEl.dataset.listingTranslations || '{}'));
}

if (mountEl) {
  const api = createSearchApi();
  const bootstrap = filterConfig;
  const { toQueryString, persist } = useCriteria();

  const rangeBounds = {
    m2: [bootstrap.bounds.m2.min, bootstrap.bounds.m2.max],
    perceel: [bootstrap.bounds.perceel.min, bootstrap.bounds.perceel.max]
  };

  const app = createApp(ListingSearchBar, {
    api,
    bootstrap,
    onSearch() {
      persist(rangeBounds);
      const queryString = toQueryString(rangeBounds);
      window.location.href = `${routes.listing}${queryString ? `?${queryString}` : ''}`;
    },
    onPickProject(project) {
      if (project && project.url) window.open(project.url, '_blank', 'noopener');
    }
  });

  app.mount(mountEl);
}
